// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widgets-icons {
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ededed;
	font-size: 26px;
	border-radius: 10px
}

.widgets-icons-2 {
	width: 56px;
	height: 56px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ededed;
	font-size: 27px;
	border-radius: 10px
}

.bg-light-primary {
	background-color: rgb(13 110 253 / .11)!important
}

.bg-light-success {
	background-color: rgb(23 160 14 / .11)!important
}

.bg-light-danger {
	background-color: rgb(244 17 39 / .11)!important
}

.bg-light-warning {
	background-color: rgb(255 193 7 / .11)!important
}

.bg-light-info {
	background-color: rgb(13 202 240 / 18%)!important
}

.bg-light-transparent {
	background-color: rgb(0 0 0 / 15%)!important
}

.bg-gradient-deepblue {
    background: #6a11cb;
		background: linear-gradient(
	45deg
	, #6a11cb , #2575fc)!important;
}


.bg-gradient-orange {
    background: #fc4a1a;
		background: linear-gradient(
	45deg
	, #fc4a1a, #f7b733)!important;
}

.bg-gradient-ohhappiness {
    background: #00b09b;
		background: linear-gradient(
	45deg
	, #00b09b, #96c93d)!important;
}


.bg-gradient-ibiza {
    background: #ee0979;
		background: linear-gradient(
	45deg
	, #ee0979, #ff6a00)!important;
}

.bg-gradient-scooter {
    background: #17ead9;
    background: linear-gradient(
45deg
, #17ead9, #6078ea)!important;
}


.bg-gradient-bloody {
    background: #f54ea2;
    background: linear-gradient(
45deg
, #f54ea2, #ff7676)!important;
}


.bg-gradient-quepal {
    background: #42e695;
    background: linear-gradient(
45deg
, #42e695, #3bb2b8)!important;
}


.bg-gradient-blooker {
    background: #ffdf40;
    background: linear-gradient(
45deg
, #ffdf40, #ff8359)!important;
}


.bg-gradient-cosmic {
	background: linear-gradient(to right, #8e2de2, #4a00e0)!important
}

.bg-gradient-burning {
	background: linear-gradient(to right, #ff416c, #ff4b2b)!important
}

.bg-gradient-lush {
	background: linear-gradient(to right, #56ab2f, #a8e063)!important
}

.bg-gradient-kyoto {
	background: linear-gradient(to right, #f7971e, #ffd200)!important
}

.bg-gradient-blues {
	background: linear-gradient(to right, #56ccf2, #2f80ed)!important
}

.bg-gradient-moonlit {
	background: linear-gradient(to right, #0f2027, #203a43, #2c5364)!important
}

.card-title{
	font-weight: 700;
	color:#333;
	font-size: 1.4rem;
	margin-top: auto;
	margin-bottom:0;
}
.statCard{
	border: 0;
	box-shadow: -2px 2px 5px #0002;
	height: 100%;
}
.statCard:hover{
	transform: translate(1px, -1px);
	box-shadow: -5px 5px 7px #0002;
}
.clickable{
	cursor: pointer;
}

.countRow{
	margin-top: .3rem;
	transition: background-color .1s;
	display: flex;
	flex-wrap: nowrap;
	border:1px solid #00000020;
	border-radius: .25rem;
	box-shadow: -2px 2px 4px #00000030;
	margin-top:10px;
	font-size: 1rem;
	font-weight: 600;
	padding:.5rem 0 .5rem 2rem;
	
	box-sizing: content-box;
}
.countRow:hover{ 
	transform: translate(1px, -1px);
	box-shadow: -5px 5px 7px #0002;
	background-color: #f3f3f3;
} 
.countRow .countRow-label{
	display: flex;
	width:100%;
	min-width: 210px;
	margin-left: 1.5rem;
}
.storeRow{
	border-left: 3px solid #fa9b1e;
	color: #fa9b1e;
}
.districtRow{
	border-left: 3px solid #e9366b;
	color: #e9366b;
}
.regionRow{
	border-left: 3px solid #09b8e4;
	color: #09b8e4;
}
.backupRow{
	border-left: 3px solid #7f7f7f;
	color: #7f7f7f;
}
.countRow .storeCount{
	display: inline-block;
	width:20%;
	text-align: right;
	margin-right:10%
}
.store-classification-chart .recharts-layer .recharts-bar-rectangles{
	cursor: pointer;
}
.year-select, .date-select {
	border: 2px solid var(--color-primary-green);
	cursor: pointer;
	background-color: #d1e4e4;
}

.createNewBtn{
	position: absolute;
    top: 30px;
    right: 50px;
    z-index: 9;
}

.floatRight{
	float: right;
}

.textEditor{
	margin-bottom: 60px;
}

.notesImgBlock img{
	width: 200px;
	height: 100px;
}
.metrics-filter-select {
	background-color: var(--color-white);
	color: var(--color-text-dark);
	border-color: var(--color-primary-green);
	appearance: none;
	padding-right: 2rem;
	background-repeat: no-repeat;
	background-position: right 0.75rem center;
	background-size: 1rem auto;
	height: calc(2.25rem + 2px);
	line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/containers/home/Dashboard.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,eAAe;CACf;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;IACI,mBAAmB;EAIrB;;+BAE6B;AAC/B;;;AAGA;IACI,mBAAmB;EAIrB;;8BAE4B;AAC9B;;AAEA;IACI,mBAAmB;EAIrB;;8BAE4B;AAC9B;;;AAGA;IACI,mBAAmB;EAIrB;;8BAE4B;AAC9B;;AAEA;IACI,mBAAmB;IAInB;;6BAEyB;AAC7B;;;AAGA;IACI,mBAAmB;IAInB;;6BAEyB;AAC7B;;;AAGA;IACI,mBAAmB;IAInB;;6BAEyB;AAC7B;;;AAGA;IACI,mBAAmB;IAInB;;6BAEyB;AAC7B;;;AAGA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,UAAU;CACV,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;AAChB;AACA;CACC,SAAS;CACT,8BAA8B;CAC9B,YAAY;AACb;AACA;CACC,+BAA+B;CAC/B,8BAA8B;AAC/B;AACA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,gCAAgC;CAChC,aAAa;CACb,iBAAiB;CACjB,0BAA0B;CAC1B,qBAAqB;CACrB,kCAAkC;CAClC,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,0BAA0B;;CAE1B,uBAAuB;AACxB;AACA;CACC,+BAA+B;CAC/B,8BAA8B;CAC9B,yBAAyB;AAC1B;AACA;CACC,aAAa;CACb,UAAU;CACV,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,8BAA8B;CAC9B,cAAc;AACf;AACA;CACC,8BAA8B;CAC9B,cAAc;AACf;AACA;CACC,8BAA8B;CAC9B,cAAc;AACf;AACA;CACC,8BAA8B;CAC9B,cAAc;AACf;AACA;CACC,qBAAqB;CACrB,SAAS;CACT,iBAAiB;CACjB;AACD;AACA;CACC,eAAe;AAChB;AACA;CACC,4CAA4C;CAC5C,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;IACf,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;AACA;CACC,oCAAoC;CACpC,6BAA6B;CAC7B,wCAAwC;CACxC,gBAAgB;CAChB,mBAAmB;CACnB,4BAA4B;CAC5B,yCAAyC;CACzC,0BAA0B;CAC1B,2BAA2B;CAC3B,gBAAgB;AACjB","sourcesContent":[".widgets-icons {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tbackground-color: #ededed;\r\n\tfont-size: 26px;\r\n\tborder-radius: 10px\r\n}\r\n\r\n.widgets-icons-2 {\r\n\twidth: 56px;\r\n\theight: 56px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tbackground-color: #ededed;\r\n\tfont-size: 27px;\r\n\tborder-radius: 10px\r\n}\r\n\r\n.bg-light-primary {\r\n\tbackground-color: rgb(13 110 253 / .11)!important\r\n}\r\n\r\n.bg-light-success {\r\n\tbackground-color: rgb(23 160 14 / .11)!important\r\n}\r\n\r\n.bg-light-danger {\r\n\tbackground-color: rgb(244 17 39 / .11)!important\r\n}\r\n\r\n.bg-light-warning {\r\n\tbackground-color: rgb(255 193 7 / .11)!important\r\n}\r\n\r\n.bg-light-info {\r\n\tbackground-color: rgb(13 202 240 / 18%)!important\r\n}\r\n\r\n.bg-light-transparent {\r\n\tbackground-color: rgb(0 0 0 / 15%)!important\r\n}\r\n\r\n.bg-gradient-deepblue {\r\n    background: #6a11cb;\r\n    background: -webkit-linear-gradient(\r\n\t45deg\r\n\t, #6a11cb, #2575fc)!important;\r\n\t\tbackground: linear-gradient(\r\n\t45deg\r\n\t, #6a11cb , #2575fc)!important;\r\n}\r\n\r\n\r\n.bg-gradient-orange {\r\n    background: #fc4a1a;\r\n    background: -webkit-linear-gradient(\r\n\t45deg\r\n\t, #fc4a1a, #f7b733)!important;\r\n\t\tbackground: linear-gradient(\r\n\t45deg\r\n\t, #fc4a1a, #f7b733)!important;\r\n}\r\n\r\n.bg-gradient-ohhappiness {\r\n    background: #00b09b;\r\n    background: -webkit-linear-gradient(\r\n\t45deg\r\n\t, #00b09b, #96c93d)!important;\r\n\t\tbackground: linear-gradient(\r\n\t45deg\r\n\t, #00b09b, #96c93d)!important;\r\n}\r\n\r\n\r\n.bg-gradient-ibiza {\r\n    background: #ee0979;\r\n    background: -webkit-linear-gradient(\r\n\t45deg\r\n\t, #ee0979, #ff6a00)!important;\r\n\t\tbackground: linear-gradient(\r\n\t45deg\r\n\t, #ee0979, #ff6a00)!important;\r\n}\r\n\r\n.bg-gradient-scooter {\r\n    background: #17ead9;\r\n    background: -webkit-linear-gradient(\r\n45deg\r\n, #17ead9, #6078ea)!important;\r\n    background: linear-gradient(\r\n45deg\r\n, #17ead9, #6078ea)!important;\r\n}\r\n\r\n\r\n.bg-gradient-bloody {\r\n    background: #f54ea2;\r\n    background: -webkit-linear-gradient(\r\n45deg\r\n, #f54ea2, #ff7676)!important;\r\n    background: linear-gradient(\r\n45deg\r\n, #f54ea2, #ff7676)!important;\r\n}\r\n\r\n\r\n.bg-gradient-quepal {\r\n    background: #42e695;\r\n    background: -webkit-linear-gradient(\r\n45deg\r\n, #42e695, #3bb2b8)!important;\r\n    background: linear-gradient(\r\n45deg\r\n, #42e695, #3bb2b8)!important;\r\n}\r\n\r\n\r\n.bg-gradient-blooker {\r\n    background: #ffdf40;\r\n    background: -webkit-linear-gradient(\r\n45deg\r\n, #ffdf40, #ff8359)!important;\r\n    background: linear-gradient(\r\n45deg\r\n, #ffdf40, #ff8359)!important;\r\n}\r\n\r\n\r\n.bg-gradient-cosmic {\r\n\tbackground: linear-gradient(to right, #8e2de2, #4a00e0)!important\r\n}\r\n\r\n.bg-gradient-burning {\r\n\tbackground: linear-gradient(to right, #ff416c, #ff4b2b)!important\r\n}\r\n\r\n.bg-gradient-lush {\r\n\tbackground: linear-gradient(to right, #56ab2f, #a8e063)!important\r\n}\r\n\r\n.bg-gradient-kyoto {\r\n\tbackground: linear-gradient(to right, #f7971e, #ffd200)!important\r\n}\r\n\r\n.bg-gradient-blues {\r\n\tbackground: linear-gradient(to right, #56ccf2, #2f80ed)!important\r\n}\r\n\r\n.bg-gradient-moonlit {\r\n\tbackground: linear-gradient(to right, #0f2027, #203a43, #2c5364)!important\r\n}\r\n\r\n.card-title{\r\n\tfont-weight: 700;\r\n\tcolor:#333;\r\n\tfont-size: 1.4rem;\r\n\tmargin-top: auto;\r\n\tmargin-bottom:0;\r\n}\r\n.statCard{\r\n\tborder: 0;\r\n\tbox-shadow: -2px 2px 5px #0002;\r\n\theight: 100%;\r\n}\r\n.statCard:hover{\r\n\ttransform: translate(1px, -1px);\r\n\tbox-shadow: -5px 5px 7px #0002;\r\n}\r\n.clickable{\r\n\tcursor: pointer;\r\n}\r\n\r\n.countRow{\r\n\tmargin-top: .3rem;\r\n\ttransition: background-color .1s;\r\n\tdisplay: flex;\r\n\tflex-wrap: nowrap;\r\n\tborder:1px solid #00000020;\r\n\tborder-radius: .25rem;\r\n\tbox-shadow: -2px 2px 4px #00000030;\r\n\tmargin-top:10px;\r\n\tfont-size: 1rem;\r\n\tfont-weight: 600;\r\n\tpadding:.5rem 0 .5rem 2rem;\r\n\t\r\n\tbox-sizing: content-box;\r\n}\r\n.countRow:hover{ \r\n\ttransform: translate(1px, -1px);\r\n\tbox-shadow: -5px 5px 7px #0002;\r\n\tbackground-color: #f3f3f3;\r\n} \r\n.countRow .countRow-label{\r\n\tdisplay: flex;\r\n\twidth:100%;\r\n\tmin-width: 210px;\r\n\tmargin-left: 1.5rem;\r\n}\r\n.storeRow{\r\n\tborder-left: 3px solid #fa9b1e;\r\n\tcolor: #fa9b1e;\r\n}\r\n.districtRow{\r\n\tborder-left: 3px solid #e9366b;\r\n\tcolor: #e9366b;\r\n}\r\n.regionRow{\r\n\tborder-left: 3px solid #09b8e4;\r\n\tcolor: #09b8e4;\r\n}\r\n.backupRow{\r\n\tborder-left: 3px solid #7f7f7f;\r\n\tcolor: #7f7f7f;\r\n}\r\n.countRow .storeCount{\r\n\tdisplay: inline-block;\r\n\twidth:20%;\r\n\ttext-align: right;\r\n\tmargin-right:10%\r\n}\r\n.store-classification-chart .recharts-layer .recharts-bar-rectangles{\r\n\tcursor: pointer;\r\n}\r\n.year-select, .date-select {\r\n\tborder: 2px solid var(--color-primary-green);\r\n\tcursor: pointer;\r\n\tbackground-color: #d1e4e4;\r\n}\r\n\r\n.createNewBtn{\r\n\tposition: absolute;\r\n    top: 30px;\r\n    right: 50px;\r\n    z-index: 9;\r\n}\r\n\r\n.floatRight{\r\n\tfloat: right;\r\n}\r\n\r\n.textEditor{\r\n\tmargin-bottom: 60px;\r\n}\r\n\r\n.notesImgBlock img{\r\n\twidth: 200px;\r\n\theight: 100px;\r\n}\r\n.metrics-filter-select {\r\n\tbackground-color: var(--color-white);\r\n\tcolor: var(--color-text-dark);\r\n\tborder-color: var(--color-primary-green);\r\n\tappearance: none;\r\n\tpadding-right: 2rem;\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: right 0.75rem center;\r\n\tbackground-size: 1rem auto;\r\n\theight: calc(2.25rem + 2px);\r\n\tline-height: 1.5;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
